import $ from 'jquery';

const MOBILE_LAYOUT = 'Mobile';

const dg = ['zero','one','two','three','four', 'five','six','seven','eight','nine'];

const $window = $(window);
const $body = $('body');
let currentScrollTop;

export const convertNumberToWord = (number) => {
    return 0 <= number && number <=9 ? dg[number] : '';
};

export const disableScroll = () => {
    if (vendor.pageInfo.getLayout() === MOBILE_LAYOUT) {
        currentScrollTop = window.pageYOffset;
        $body.addClass('product-model-compare-bucket-open').css({top: `-${currentScrollTop}px`});
    }
};

export const enableScroll = () => {
    if (vendor.pageInfo.getLayout() === MOBILE_LAYOUT) {
        $body.removeClass('product-model-compare-bucket-open').css({top: ''});
        $window.scrollTop(currentScrollTop);
    }
};

export const disableCompareBucketBackground = () => {
    if (vendor.pageInfo.getLayout() === MOBILE_LAYOUT) {
        $('.product-model-compare-bucket-background').remove();
    }
};

export const enableCompareBucketBackground = () => {
    if (vendor.pageInfo.getLayout() === MOBILE_LAYOUT) {
        $body.append($('<div class="product-model-compare-bucket-background"></div>'));
    }
};



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/CompareBucketRedux/utils/index.js